import { useGetQuery } from '@/hooks/api/useGetQuery';
import { queryKeys } from '@/queries/query-keys';

/** GET `/admin/account` — shared session query (bootstrap + org switcher gating). */
export function useSessionQuery(options = {}) {
  return useGetQuery(() => '/admin/account', {}, queryKeys.session(), {
    retry: false,
    staleTime: Infinity,
    ...options,
    meta: { skipErrorSnack: true, ...options.meta },
  });
}
